import styled from "styled-components";

const StyledFooterLogo = styled.p`
    position: absolute;
    left: 10rem;
    right: 10rem;
    bottom: 2.5rem;
    text-align: center;
    @media print {
        position: fixed;
        bottom: 1rem;
        left: 2rem;
        right: 2rem;
        font-size: 0.8rem;
    }
`;

export default StyledFooterLogo;
